import Vue from 'vue'
import Router from 'vue-router'
/*
 *引入页面页面
 */
// const creat_test =()=> import ('@/peges/creat_test.vue');   		//----创建试卷
Vue.use(Router)

/* router/router.js */
/* 初始路由 */
const router = [
  // {
  // 	path: '/',
  // 	name: 'creat_test',
  // 	redirect:'http://czwl.cooco.net.cn/'
  // },
  {
    path: '/',
    name: 'creat_test',
    // component: creat_test,
    component: () => import(/* webpackChunkName: 'creat_test' */ '@/peges/creat_test.vue'),
    meta: {
      title: '智能组卷'
    }
  }
];

export default new Router({
  mode: "history",
  routes: router
});



// WEBPACK FOOTER //
// ./src/router/router.js